module.exports = __webpack_public_path__ + "static/20-76bb8fffe4e4d60d798ec065dcbfabeb.jpg";